// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"411":"a109ccd5","453":"184514bb"}[chunkId] + ".chunk.js";
};